import React, { useEffect, useState, useRef } from 'react';

import { Link, useHistory } from 'react-router-dom';

// import { Link } from 'react-router-dom';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
  MDBCard,
  MDBCardBody,
} from 'mdbreact';
import NavBar from '../../../components/NavBar';
import api from '../../../services/api';
import { format } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import Loading from '../../../components/Loading';

import SendImg from '../../../components/SendImg';
import Select from 'react-select';

import resolverMensagemErro from '../../../utils/resolverMensagemErro';
import RelatorioPdf from '../Components/RelatorioPdf';
import { toast } from 'react-toastify';
// import { Container } from './styles';

export default function App() {
  let history = useHistory();
  const [abordagens, setAbordagens] = useState([]);
  const [loading, setLoading] = useState(false);

  const [qtdTotal, setQtdTotal] = useState(0);
  const [page, setPage] = useState('1');

  const [modalFoto, setModalFoto] = useState(null);

  // Pré-seleciona "Sem anexo" quando chega pelo link do alerta da navbar
  // (/minhas-abordagens?sem_anexo=true), já carregando a lista filtrada.
  const [selectRevisao, setSelectRevisao] = useState(() =>
    new URLSearchParams(window.location.search).get('sem_anexo') === 'true'
      ? { label: 'Sem anexo', value: 'sem_anexo' }
      : { label: 'Todas' }
  );

  const [idAbordagem, setIdAbordagem] = useState(null);
  const [searchAbordagem, setSearchAbordagem] = useState(false);

  // Filtros de data. "Cadastrada a partir de" (created_at) vem pré-preenchido
  // pelo link do alerta (?desde=YYYY-MM-DD) para a lista bater com a contagem
  // do alerta; "Abordagem a partir de" (dt_h_inicio) é filtro geral opcional.
  const [desdeCadastro, setDesdeCadastro] = useState(
    () => new URLSearchParams(window.location.search).get('desde') || ''
  );
  const [desdeAbordagem, setDesdeAbordagem] = useState('');
  const primeiraRenderDatas = useRef(true);

  const minhasAbordagens = async () => {
    setLoading(true);
    const params = { pag: page };
    if (selectRevisao.value === 'idabordagem') {
      if (idAbordagem === null) {
        setAbordagens([]);
        setLoading(false);
        setQtdTotal(1);
        return;
      }
      params.abordagem_id = idAbordagem;
    } else if (selectRevisao.value === 'sem_anexo') {
      params.sem_anexo = true;
    } else {
      params.revisao = selectRevisao.value;
    }

    if (desdeCadastro) params.desde = desdeCadastro;
    if (desdeAbordagem) params.desde_abordagem = desdeAbordagem;

    // [#217] O setLoading(false) fica no finally: sem ele, uma falha do GET
    // deixava o spinner girando para sempre e sem mensagem nenhuma.
    try {
      let result = await api.get('/minhas-abordagens', {
        params,
      });

      result.data.rows.map(abord => {
        let qtdRev = 0;
        let qtdAb = 0;
        abord.sgo_revisaos.forEach(rev => {
          if (rev.data_final === null) {
            if (rev.data_resposta === null) {
              qtdRev++;
            } else {
              qtdAb++;
            }
          }
        });

        const newRow = [];
        abord.ocorrencia.forEach(oco => {
          if (oco.ativo === true) newRow.push(oco);
        });
        abord.revisao_aberta = qtdRev;
        abord.revisao_resposta = qtdAb;

        abord.ocorrencia = newRow;
      });

      setAbordagens(result.data.rows);

      setQtdTotal(Math.ceil(Number(result.data.count) / Number(10)));
    } catch (err) {
      toast.error(resolverMensagemErro(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    minhasAbordagens();
  }, [page]);

  useEffect(() => {
    if (selectRevisao.value === 'idabordagem') {
      setSearchAbordagem(true);
      setAbordagens([]);
      setPage(1);
      return;
    } else {
      setIdAbordagem(null);
      setSearchAbordagem(false);
    }
    page === 1 && minhasAbordagens();
    setPage(1);
  }, [selectRevisao]);

  useEffect(() => {
    minhasAbordagens();
  }, []);

  // re-busca quando os filtros de data mudam (pula a 1ª render p/ não duplicar
  // com os fetches de montagem acima).
  useEffect(() => {
    if (primeiraRenderDatas.current) {
      primeiraRenderDatas.current = false;
      return;
    }
    setPage(1);
    minhasAbordagens();
  }, [desdeCadastro, desdeAbordagem]);

  return (
    <NavBar>
      <MDBContainer fluid>
        <MDBRow className="h4-responsive" center>
          Abordagens
        </MDBRow>
        <MDBRow className="h4-responsive justify-content-center ">
          <MDBBtn onClick={() => history.push(`/add-abordagem`)}>
            Nova Abordagem
          </MDBBtn>
        </MDBRow>
        <MDBRow center>Minhas Abordagens</MDBRow>

        <MDBCard>
          <MDBCardBody>
            <MDBRow className="align-items-center">
              <MDBCol
                className="mx-3 align-items-center justify-content-center"
                size="11"
                md="3"
              >
                <Select
                  options={[
                    { label: 'Todas', value: 'Todas' },
                    { label: 'Aberta', value: 'Aberta' },
                    { label: 'Respondida', value: 'Respondida' },
                    { label: 'Finalizada', value: 'Finalizada' },
                    { label: 'Sem anexo', value: 'sem_anexo' },
                    { label: 'ID ABORDAGEM', value: 'idabordagem' },
                  ]}
                  onChange={e => setSelectRevisao(e)}
                  value={selectRevisao}
                />
              </MDBCol>

              <MDBCol size="6" md="3" className="mt-2 mt-md-0">
                <label className="grey-text small mb-0 text-truncate d-block">
                  Cadastro a partir de
                </label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={desdeCadastro}
                  onChange={e => setDesdeCadastro(e.target.value)}
                />
              </MDBCol>
              <MDBCol size="6" md="3" className="mt-2 mt-md-0">
                <label className="grey-text small mb-0 text-truncate d-block">
                  Abordagem a partir de
                </label>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={desdeAbordagem}
                  onChange={e => setDesdeAbordagem(e.target.value)}
                />
              </MDBCol>

              {searchAbordagem === true && (
                <>
                  <MDBCol col="12" md="6">
                    <MDBInput
                      label="Número da Abordagem"
                      outline
                      type="number"
                      maxLength="11"
                      onChange={e => setIdAbordagem(e.target.value)}
                      value={idAbordagem}
                      // onChange={e => setRenavam(e.target.value.toUpperCase())}
                      // value={renavam}
                      // onChange={e => this.setState({ renavam: e.target.value })}
                    />
                  </MDBCol>
                  <MDBCol className="text-center">
                    <MDBBtn onClick={() => minhasAbordagens()} size="sm">
                      Buscar
                    </MDBBtn>
                  </MDBCol>
                </>
              )}
            </MDBRow>
          </MDBCardBody>
        </MDBCard>

        <MDBRow
          style={{ borderRadius: '5px' }}
          className="p-2 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 align-items-center grey darken-1  d-none d-md-flex text-white font-weight-bolder"
        >
          <MDBCol size="12" md="1">
            N:
          </MDBCol>
          <MDBCol size="12" md="3">
            Gerência / Ala
          </MDBCol>
          <MDBCol size="12" md="2">
            Cadastro:
          </MDBCol>
          <MDBCol size="12" md="2">
            Início:
          </MDBCol>
          <MDBCol size="12" md="1">
            Ocorr.:
          </MDBCol>
          <MDBCol size="12" md="3"></MDBCol>
          {/* <div className="col-12 col-md-3 font-weight-bold text-white">
            Gerência / Ala
          </div>
          <div className="col-12 col-md-3 font-weight-bold text-white">
            Início da Abordagem:
          </div>

          <div className="col-12 col-md-1 font-weight-bold text-white">
            Ocorrências:
          </div>
          <div className="col-12 col-md-3 d-flex font-weight-bold text-white">
            sd
          </div> */}
          {/* <div className="col-12 col-md-1 d-flex flex-column font-weight-bold text-white">
            <span>Frequência</span> */}
          {/*
                    <span className="text-danger">Ausentes</span> */}
          {/* </div> */}
        </MDBRow>
        {loading === true ? (
          <Loading />
        ) : (
          abordagens.length !== 0 &&
          abordagens.map(abordagem => (
            <>
              <MDBRow
                key={abordagem.id}
                style={{ borderRadius: '5px' }}
                className="p-2 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 align-items-center bg-white"
              >
                <MDBCol
                  size="12"
                  md="1"
                  className="font-weight-bolder blue-grey-text"
                >
                  #{abordagem.id}
                </MDBCol>
                <div className="col-12 col-md-3 mb-md-0 d-flex justify-content-between justify-content-md-start align-items-center">
                  {/* {abordagem.sgo_revisaos.length > 0 &&
                    abordagem.sgo_revisaos.map(rev => {
                      rev.revisor_final_id === null ?
                      return (

                      );
                    })} */}

                  {abordagem.revisao_aberta > 0 ? (
                    abordagem.revisao_aberta > 1 ? (
                      <>
                        <span className="font-weight-bolder mr-1">
                          {abordagem.revisao}
                        </span>
                        <MDBIcon className="mr-2 red-text" icon="circle" />
                      </>
                    ) : (
                      <MDBIcon className="mr-2 red-text" icon="circle" />
                    )
                  ) : abordagem.revisao_resposta > 0 ? (
                    <MDBIcon className="mr-2 blue-text" icon="circle" />
                  ) : (
                    ''
                  )}
                  {`${abordagem.lotacao.gerencia.nome} / ${abordagem.lotacao.ala.nome}`}
                </div>
                <div className="col-12 col-md-2 mb-md-0 d-flex justify-content-between justify-content-md-start">
                  <span className="d-sm-inline d-md-none text-muted">Cadastro:</span>
                  <span>
                    {abordagem.createdAt
                      ? format(
                          zonedTimeToUtc(
                            new Date(abordagem.createdAt),
                            'America/Sao_Paulo'
                          ),
                          'dd/MM/yyyy'
                        )
                      : '—'}
                  </span>
                </div>
                <div className="col-12 col-md-2 mb-md-0 d-flex justify-content-between justify-content-md-start">
                  <span className="d-sm-inline d-md-none text-muted">Início:</span>
                  <span>
                    {format(
                      zonedTimeToUtc(
                        new Date(abordagem.dt_h_inicio),
                        'America/Sao_Paulo'
                      ),
                      'dd/MM/yyyy - HH:mm'
                    )}
                  </span>
                </div>
                <div className="col-12 col-md-1 mb-md-0 d-flex justify-content-between justify-content-md-center font-weight-bolder">
                  <span className="d-sm-inline d-md-none text-muted">
                    Ocorrências:
                  </span>

                  <span title="Ocorrências registradas nesta abordagem">
                    {abordagem.ocorrencia.length}
                  </span>
                </div>

                <div className="col-12 col-md-3 mt-3 mt-md-0 d-flex flex-wrap justify-content-around justify-content-md-end align-items-center font-weight-bold">
                  <Link
                    to={`/add-ocorrencia/${abordagem.id}`}
                    className="text-success d-flex align-items-center mr-md-4"
                    title="Adicionar ocorrência"
                    style={{ cursor: 'pointer' }}
                  >
                    <MDBIcon icon="plus" size="lg" />
                    <span className="d-md-none ml-2">Ocorrência</span>
                  </Link>

                  <div
                    className={`d-flex align-items-center mr-md-4 ${
                      Number(abordagem.qtd_anexos) === 0 ? 'text-danger' : ''
                    }`}
                    onClick={() => setModalFoto(abordagem.id)}
                    title={
                      Number(abordagem.qtd_anexos) === 0
                        ? 'Nenhuma foto/PDF anexado — clique para adicionar'
                        : `${abordagem.qtd_anexos} anexo(s) (fotos/PDFs) — clique para ver ou adicionar`
                    }
                    style={{ cursor: 'pointer' }}
                  >
                    <MDBIcon
                      icon={
                        Number(abordagem.qtd_anexos) === 0
                          ? 'exclamation-triangle'
                          : 'paperclip'
                      }
                      size="lg"
                    />
                    <span className="ml-2">
                      {Number(abordagem.qtd_anexos) || 0}
                    </span>
                    <span className="d-md-none ml-2">anexos</span>
                  </div>

                  <RelatorioPdf abordagemId={abordagem.id} compacto className="mr-md-4" />

                  {/* [#256] linha com quatro comandos numa coluna de 25%:
                      aqui todos ficam só com o ícone no desktop (o nome volta
                      no celular), para nenhum destoar do vizinho. */}
                  <Link
                    to={`/abordagem/${abordagem.id}`}
                    className="d-flex align-items-center"
                    title="Ver abordagem"
                    style={{ cursor: 'pointer', color: '#59698d' }}
                  >
                    <MDBIcon far icon="eye" size="lg" />
                    <span className="d-md-none ml-2">Ver</span>
                  </Link>
                </div>
              </MDBRow>
            </>
          ))
        )}
        {loading === true ? (
          ''
        ) : (
          <MDBRow center className="my-4 align-items-center">
            <div>
              Página {page} de {qtdTotal}
            </div>
            <MDBIcon
              className="mx-3"
              onClick={e => {
                if (page == 1) {
                  return;
                }
                setPage(Number(page) - 1);
              }}
              style={{
                fontSize: '30px',
                cursor: 'pointer',
              }}
              icon="angle-left"
            />
            |
            <MDBIcon
              className="mx-3"
              onClick={e => {
                if (page >= qtdTotal) {
                  return;
                }
                setPage(Number(page) + 1);
              }}
              style={{
                fontSize: '30px',
                cursor: 'pointer',
              }}
              icon="angle-right"
            />
          </MDBRow>
        )}
      </MDBContainer>
      {/* MODAL PARA CRIACAO DE VEICULOS */}
      <MDBModal
        isOpen={modalFoto}
        toggle={() => {
          setModalFoto(null);
        }}
      >
        <MDBModalHeader
          toggle={() => {
            setModalFoto(null);
          }}
        >
          Inserir Foto
        </MDBModalHeader>
        <MDBModalBody>
          <MDBRow center>
            <MDBCol size="12" middle>
              <SendImg
                // abordagem_id={modalFoto}
                maxImages="10"
                getFotos={{
                  buscaFotosURL: '/sgo-imagem',
                  buscaFotosWhere: { abordagem_id: modalFoto },
                }}
                postFotos={{
                  enviarFotoURL: '/sgo-insere-imagem',
                  enviarRefId: { abordagem_id: modalFoto },
                }}
                deleteFotos={{
                  deletarFotoURL: '/sgo-delete-img',
                  // refId: { id: modalFoto },
                }}
              />
            </MDBCol>
          </MDBRow>
        </MDBModalBody>
        <MDBModalFooter center>
          <MDBBtn
            color="danger"
            onClick={() => {
              setModalFoto(null);
            }}
          >
            Cancelar
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>
    </NavBar>
  );
}
